export type Category = {
  id: string;
  type: 'category';
  title: string;
  slug: string;
};